import {
    onDateTimesChanged,
    setShowDateSelectorTimeZones,
    updateDateTimes,
} from 'owa-calendar-compose-form-actions';
import { logChangeTimeActions } from 'owa-calendar-compose-form-actions/lib/actions/eventMetricsActions';
import {
    getComposeEvent,
    getOriginalEvent,
    getFullComposeViewState,
} from 'owa-calendar-compose-store-manager';
import { KnownItemTypes } from 'owa-calendar-surface-dategrid';
import { refreshTimeSuggestions } from 'owa-calendar-time-suggestions';
import { orchestrator } from 'satcheljs';
import {
    updateSelectionItem,
    convertToSchedulingSelectionItem,
    navigateToDate,
} from 'owa-calendar-scheduling-grid';
import { isEqual } from 'owa-datetime';
import refreshLocationSuggestions from '../utils/refreshLocationSuggestions';
import { TimeChangeActionType } from 'owa-calendar-helpers-types/lib/TimeChangeActionType';
import fetchRecurrentEventResourcesAvailability from '../utils/fetchRecurrentEventResourcesAvailability';
import triggerAppointmentTimeChanged from '../utils/triggerAppointmentTimeChanged';
import { prefetchRoomsAvailabilityForRoomPanel } from '../utils/prefetchRoomsAvailabilityForRoomPanel';
import hasCustomTimeZones from 'owa-calendar-compose-form-store/lib/utils/hasCustomTimeZones';
import { isFeatureEnabled } from 'owa-feature-flags';
import enableDefaultOnlineMeeting from '../utils/enableDefaultOnlineMeeting';

export default orchestrator(updateDateTimes, ({ formId, datesSelected, timeChangeActionType }) => {
    const fullComposeViewState = getFullComposeViewState(formId);
    const calendarEvent = getComposeEvent(formId);
    const originalEvent = getOriginalEvent(formId);
    const startDateChanged = !isEqual(datesSelected.start, calendarEvent.Start);
    const endDateChanged = !isEqual(datesSelected.end, calendarEvent.End);

    if (
        isFeatureEnabled('addin-fix-recurrenceTimezone') &&
        hasCustomTimeZones(datesSelected.start.tz, datesSelected.end.tz)
    ) {
        setShowDateSelectorTimeZones(true, formId);
    }
    onDateTimesChanged(datesSelected, formId);

    // Don't refresh suggestions when the last time change comes from time suggestions
    if (
        timeChangeActionType !== TimeChangeActionType.TimeSuggestions &&
        timeChangeActionType !== TimeChangeActionType.TimeSuggestionsSearchCriteria
    ) {
        refreshTimeSuggestions(calendarEvent, false /* attendeesChanged */, formId);
    }

    refreshLocationSuggestions(formId);

    // Full compose can be null when the opened form is Quick compose
    if (fullComposeViewState) {
        updateSelectionItem(
            fullComposeViewState.schedulingGridScenarioId,
            convertToSchedulingSelectionItem(
                { ...calendarEvent, Start: datesSelected.start, End: datesSelected.end },
                KnownItemTypes.suggestedItems
            )
        );

        if (startDateChanged && endDateChanged) {
            navigateToDate(fullComposeViewState.schedulingGridScenarioId, datesSelected.start);
        }

        // if in fullCompose prefetch room availabilities
        prefetchRoomsAvailabilityForRoomPanel(
            calendarEvent.Start,
            calendarEvent.End,
            calendarEvent.IsAllDayEvent,
            calendarEvent.Recurrence,
            calendarEvent.RequiredAttendees,
            calendarEvent.OptionalAttendees,
            originalEvent,
            formId
        );
    }

    // Fetch availability for the resources of recurrent event. This is only for logging for experiment. We fetch the availabilities for all rooms in the Location well
    // using GetRoomAvailability, even when the flight 'cal-mf-availabilityForRecurrence' is off, to compare this availabilities between treatment and control.
    // TODO: Remove this when experiment is over (https://exp.microsoft.com/Rollout?id=f3d8a340-9076-46ee-8db1-d8e17e131b38)
    fetchRecurrentEventResourcesAvailability(calendarEvent);
    triggerAppointmentTimeChanged(formId);
    enableDefaultOnlineMeeting(calendarEvent, formId);
    logChangeTimeActions(timeChangeActionType, formId);
});
